<!-- begin::Toggle -->
<div class="account-trigger__minimized btn btn-icon btn-icon-primary btn-light btn-active-light-primary">
  <span
    [inlineSVG]="'./assets/media/icons/duotune/general/gen025.svg'"
    class="svg-icon svg-icon-1"
  ></span>
</div>
<a
  class="
    account-trigger__base
    justify-content-between
    rotate btn btn-bg-light btn-active-color-primary btn-rounded
    px-3
">
  <span class="text-truncate">
    <ng-content></ng-content>
  </span>
  <i class="rotate-180 bi bi-chevron-down p-0"></i>
</a>
<!-- end::Toggle  -->

